import DetailPenawaran from './DetailPenawaran';

export default DetailPenawaran